export default [
  {
    date: "12/11",
    description: "Metodologias ageis um conceito cada vez mais em foco",
    place: "101C",
    speaker: "Vinícius de Pádua Bertoldo Costa",
    time: null,
  },
  {
    date: "12/11",
    description: "Fluig e ferramentas da plataforma",
    place: "102C",
    speaker: "Luvânio Lopes",
    time: null,
  },
  {
    date: "12/11",
    description: "Introdução à ciência de dados",
    place: "103C",
    speaker: "Anderson da Silva soares",
    time: null,
  },
  {
    date: "12/11",
    description: "Utilizando Python em Pentesting",
    place: "104C",
    speaker: "Rafael Leal Martins",
    time: null,
  },
  {
    date: "12/11",
    description: "Micropython com ESP32",
    place: "105C",
    speaker: "Daniel Corrêa da Silva",
    time: null,
  },
  {
    date: "13/11",
    description: "Introdução a visão computacional",
    place: "101C",
    speaker: "Gustavo Teodoro Laureano",
    time: null,
  },
  {
    date: "13/11",
    description: "Python para Ciência de Dados",
    place: "102C",
    speaker: "Cristiano Borges",
    time: null,
  },
  {
    date: "13/11",
    description: "Introdução a FPGA",
    place: "103C",
    speaker: "Gustavo Siqueira Vinhal",
    time: null,
  },
  {
    date: "14/11",
    description: "Introdução a Internet das Coisas",
    place: "101C",
    speaker: "Ludmilla Reis Pinheiros",
    time: null,
  },
  {
    date: "14/11",
    description: "Conhecendo o Docker",
    place: "103C",
    speaker: "Daniel Vitor Lucena",
    time: null,
  },
  {
    date: "14/11",
    description: "Introdução a Inteligencia Artificial",
    place: "104C",
    speaker: "Ricardo Augusto Pereira",
    time: null,
  },
];
